import type { ComponentPropsWithoutRef } from 'react';
import React from 'react';

interface HeadingProps extends ComponentPropsWithoutRef<'h1' | 'h2'> {
  children: React.ReactNode;
  level: number;
}

export const Heading = ({ children, level, ...props }: HeadingProps) => {
  const HeadingTag = `h${level}`;

  return <HeadingTag {...props}>{children}</HeadingTag>;
};
